import { NavLink, Outlet } from "react-router-dom";
import { ROUTES } from "@routing/routes";

// Layout route for the /c/account subtree (#162): one persistent tab strip
// above every account page, so the sections are reachable from each other
// rather than only from the dashboard. The URL is the source of truth for the
// active tab — NavLink sets aria-current="page" on the matching link.
//
// Theme quirk: --color-base-content is #fff on the light theme, so the
// inactive chips need an explicit readable text token (text-neutral). The
// active chip is the solid dark chip the mockup uses (btn-neutral).
const TAB_BASE_CLASSES =
    "btn btn-sm rounded-full font-semibold normal-case shrink-0";
const TAB_INACTIVE_CLASSES = "bg-base-200 border-base-300 text-neutral";
const TAB_ACTIVE_CLASSES = "btn-neutral";

const ACCOUNT_TABS = [
    // `end`: the index route would otherwise match every /c/account/* URL.
    { label: "Dashboard", to: ROUTES.ACCOUNT, end: true },
    { label: "Orders", to: ROUTES.ACCOUNT_ORDERS, end: false },
    { label: "Locations", to: ROUTES.ACCOUNT_LOCATIONS, end: false },
    { label: "Membership", to: ROUTES.ACCOUNT_MEMBERSHIP, end: false },
    { label: "Invoices", to: ROUTES.ACCOUNT_BILLING, end: false },
    { label: "Profile", to: ROUTES.ACCOUNT_PROFILE, end: false },
];

export const AccountLayout = () => {
    return (
        <div className="bg-base-100 text-neutral">
            <nav
                aria-label="Account"
                className="max-w-3xl mx-auto px-4 pt-6 md:pt-8"
            >
                {/* Mobile: one horizontally scrollable row; desktop: wraps. */}
                <ul className="flex gap-2 overflow-x-auto md:flex-wrap">
                    {ACCOUNT_TABS.map((tab) => (
                        <li key={tab.to} className="shrink-0">
                            <NavLink
                                to={tab.to}
                                end={tab.end}
                                className={({ isActive }) =>
                                    `${TAB_BASE_CLASSES} ${
                                        isActive
                                            ? TAB_ACTIVE_CLASSES
                                            : TAB_INACTIVE_CLASSES
                                    }`
                                }
                            >
                                {tab.label}
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </nav>
            <Outlet />
        </div>
    );
};
